import React from "react";
import "./App.css";
import FilmSubmissionForm from "./Components/FilmSubmissionForm";
import ZeeGauravbg from "./Assets/ZeeGauravbg.jpg";
import ChitraGauravLogo from "./Assets/chitragauravlogo.png";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img
          src={ChitraGauravLogo}
          alt="Zee Marathi Gaurav Puraskar Logo"
          className="app-logo"
        />
        <h2>झी चित्र गौरव पुरस्कार २०२६ - Zee Chitra Puraskar 2026</h2>

        <p>
          दिनांक <strong>१ जानेवारी २०२५</strong> ते{" "}
          <strong>३१ डिसेंबर २०२५</strong> या कालावधीत प्रदर्शित झालेल्या नवीन
          मराठी चित्रपटांसाठी
          <br />
          <em style={{ display: "block", textAlign: "center" }}>
            For films released between <strong>1 January 2025</strong> and{" "}
            <strong>31 December 2025</strong>
          </em>
        </p>

        <FilmSubmissionForm />
      </header>
    </div>
  );
}

export default App;
